import { useEffect } from "react";

const PAGE_NAMES = {
  "/leistungen": "Leistungen",
  "/zeremonien": "Zeremonien",
  "/mark-daviz": "Mark Daviz",
  "/angela-puxi": "Angela Puxi",
  "/kosten": "Kosten",
  "/partner": "Partner",
  "/hoerbeispiele": "Hörbeispiele",
  "/impressum": "Impressum",
  "/datenschutz": "Datenschutz",
  "/freie-trauung-krefeld": "Freie Trauung Krefeld",
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const SEO = ({ title, description, path = "/", image = "/images/hero.webp", jsonLd = null, noindex = false }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path}`;
    const img = image.startsWith("http") ? image : `${origin}${image}`;

    document.title = title;
    setMeta("name", "description", description);
    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "de_DE");
    setMeta("property", "og:site_name", "Daviz & Puxi – Freie Trauung Deluxe");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    const payloads = [];
    if (jsonLd) payloads.push(...(Array.isArray(jsonLd) ? jsonLd : [jsonLd]));
    if (path !== "/" && PAGE_NAMES[path]) {
      payloads.push({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Start", item: `${origin}/` },
          { "@type": "ListItem", position: 2, name: PAGE_NAMES[path], item: url },
        ],
      });
    }
    let script = document.getElementById("seo-jsonld");
    if (payloads.length) {
      if (!script) {
        script = document.createElement("script");
        script.id = "seo-jsonld";
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(payloads);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd, noindex]);
  return null;
};

export default SEO;
